import { Colorpicker as ColorPicker } from 'antd-colorpicker';
import type { StyledComponent } from 'styled-components';
import styled from 'styled-components';

export const StyledColorPicker: StyledComponent<typeof ColorPicker, any> = styled(ColorPicker)``;
